import React from 'react'
import Navbar from '../Components/Navbar'
import Footer from '../Components/Footer'

const companies = [
  {
    name: 'Nikxury Infrastructure',
    description: 'Pioneering infrastructure development with a focus on sustainable and innovative solutions. We build the foundation for tomorrow\'s cities with cutting-edge technology and engineering excellence.'
  },
  {
    name: 'NIKXONE',
    description: 'Your premier partner in real estate development, offering end-to-end solutions from concept to completion. We specialize in creating spaces that inspire and endure.'
  },
  {
    name: 'X One Developers',
    description: 'Leading real estate development company specializing in innovative residential and commercial properties. We transform visions into reality with sustainable and modern architectural solutions.'
  },
  {
    name: 'ONE X DREAMS',
    description: 'Transforming dreams into addresses. We create exceptional living and working spaces that combine luxury, functionality, and sustainable design for the modern world.'
  }
];

function OurCompanies() {
  return (
    <>
      <Navbar/>
      <div className='banner banner8'>
        <h2 data-aos="fade-right">Our Companies</h2>
        <p data-aos="fade-right">Home / Companies</p>
      </div>
      <div className='our-companies-container'>
        {companies.map((company, index) => (
          <div className='OurCompanies' key={index}>
            <div className='OurCompanies-left'>
              <h2>{company.name}</h2>
              <p>Read More</p>
            </div>
            <div className='OurCompanies-right'>
              <div className='OurCompanies-para'>
                <p>{company.description}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
      <Footer/>
    </>
  )
}

export default OurCompanies